const initialState = {
    connected: false,
    message: undefined,
    event: undefined,
    url: undefined,
    token: undefined,
    imageVersion: new Date().getTime()
};

function websocketReducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'WEBSOCKET_CONNECTED':
            return {
                ...state,
                connected: true
            };

        case 'WEBSOCKET_DISCONNECTED':
            return {
                ...state,
                connected: false
            };

        case 'WEBSOCKET_MESSAGE':
            return {
                ...state,
                message: action.event
            };

        case 'WEBSOCKET_EVENT':
            return {
                ...state,
                event: action.event
            };

        case 'WEBSOCKET_CLEAR_EVENT':
            return {
                ...state,
                event: null
            };

        case 'WEBSOCKET_TOKEN':
            return {
                ...state,
                url: action.url,
                token: action.token
            };

        case 'IMAGE_VERSION_UPDATE':
            return {
                ...state,
                imageVersion: new Date().getTime()
            };
        default:
            return state;
    }
}

export default websocketReducer;
